import React, { useState, useEffect, useContext } from "react"

import { AppContext } from "../../AppContext";
import LoadingComp from "../common/LoadingComp";
import ErrorComp from "../common/ErrorComp";
import AttestationErrorComp from "./AttestationErrorComp";
import AttestationForm from "./AttestationForm";
import AttestationService from "../../services/AttestationService";

const AttestationFormComp = (props) => {
    const messageId = props.match.params.id;

    const [appContext, setAppContext] = useContext(AppContext);
    const [showAttestationError, setShowAttestationError] = useState(false);
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [currentItem, setCurrentItem] = useState({ status: "" });

    const handleDetails = (messageId) => {
        setLoading(true);
        
        AttestationService.GetDetails(messageId, false)
            .then((result) => {
              setLoading(false);
              if (result) {
                setCurrentItem(result);
              } else {
                setShowAttestationError(true);
              }
            },
            (err) => {
              setLoading(false);
              setShowError(true);
            }
        );
    };

    const handleSaveClick = (item) => {
        AttestationService.SaveForm(item);
    };

    const handleSubmitClick = (item) => {
        AttestationService.SubmitForm(item)
            .then((res) => {
                redirectToMyAttestations();
            })
            .catch((err) => {
                setShowError(true);
            });
    };

    const handleClose=()=>{
        redirectToMyAttestations();
    };

    const redirectToMyAttestations = () => {
        window.location.replace("/attestation");
    }

    useEffect(() => {
        if (messageId) {
            handleDetails(messageId);
        } else {
            setShowError(true);
        }
    }, []);

    return (
        <div className={appContext.sidebarCollapsed?"content-wrapper sidebar-collapsed":"content-wrapper"}>
            <section className="section-wrapper">
            <div className="page-title no-print">My Attestation Documents</div>
                <div className="section-content">
                    <div className="panel">
                        <div className="panel-header">
                            <div className="panel-header-label">Attestation Documents</div>
                        </div>
                        {!showError && !showAttestationError && 
                            <AttestationForm editorItem={currentItem} handleSubmitClick={handleSubmitClick} 
                                handleSaveClick={handleSaveClick} handleClose={handleClose} />
                        }
                        {showAttestationError && <AttestationErrorComp />}
                        {showError && <ErrorComp />}
                        {loading && <LoadingComp />}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AttestationFormComp;